import FileImportReader from '@/agilis/components/DataTableV2/DataTableV2ImportReader/FileImportReader.vue'
import SearchPaginatedMixin from '@/agilis/components/DataTableV2/common/searchPaginatedMixin'
import TrackerDataTableMixin from './TrackerDataTable'

export default {
  name: 'TrackerDataTablePaginated',
  mixins: [TrackerDataTableMixin, SearchPaginatedMixin],
  components: {
    FileImportReader
  },

  methods: {
    requestDataReload (event) {
      if (this.fetchData) {
        this.fetchData()
      }
    }
  }
}
